import React, { useRef, useState } from "react";
import { VennDiagramHeader } from "./VennDiagramHeader";
import { VennDiagramActions } from "./VennDiagramActions";
import { VennDiagramCanvas } from "./VennDiagramCanvas";
import { VennDiagramModal } from "./VennDiagramModal";
import { useVennDiagramExport } from "./hooks/useVennDiagramExport";
import type { VennDiagramData } from "@/lib/chat/parseVennDiagramBlock";

interface VennDiagramProps {
  data: VennDiagramData;
}

export const VennDiagram: React.FC<VennDiagramProps> = ({ data }) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { exportPNG } = useVennDiagramExport(exportRef, data.title);

  return (
    <>
      <div className="relative w-full overflow-hidden rounded-xl border border-border/60 bg-card shadow-sm">
        <div ref={exportRef}>
          <VennDiagramHeader title={data.title} />
          <VennDiagramCanvas data={data} />
        </div>
        <VennDiagramActions
          onDownload={exportPNG}
          onExpand={() => setExpanded(true)}
        />
      </div>

      <VennDiagramModal
        open={expanded}
        onClose={() => setExpanded(false)}
        data={data}
      />
    </>
  );
};
